import type { TinyTableData } from './TinyTable';

import TinyTable from './TinyTable';

export type { TinyTableData };
export default TinyTable;
